<template>
    <v-dialog 
        v-model="dialog" 
        :scrollable="scrollable" 
        :max-height="maxHeight" 
        :max-width="($vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm') ? '90%' : maxWidth" 
        :hide-overlay="hideOverlay"
        :persistent="persistent">

        <slot name="body" />
        
        <!-- Esse trecho faz com que o componente pai possa usar qualquer slot do v-data-table -->
        <template v-for="slot in Object.keys($scopedSlots)" :slot="slot" slot-scope="scope">
            <slot :name="slot" v-bind="scope"/>
        </template>
        
    </v-dialog>
</template>

<script setup>

import { computed, defineProps, defineEmits } from 'vue'

const emit = defineEmits(['update:show'])

const props = defineProps({
    show: { type: Boolean, default: false },
    scrollable: { type: Boolean, default: false },
    persistent: { type: Boolean, default: true },
    maxHeight: { type: String, default: 'auto' },
    maxWidth: { type: String, default: "80%" },
    hideOverlay: { type: Boolean, default: false }
});

const dialog = computed({
    get() {
        return props.show
    },
    set(value) {
        emit('update:show', value)
    }
})

</script>